<template>
  <div class="interest-page">
    <div class="page-hero">
      <van-nav-bar
        :title="pageTitle"
        left-arrow
        :border="false"
        @click-left="onCancal"
      />

      <div class="hero-card">
        <!-- <div class="hero-title">{{ pageTitle }}</div> -->
        <div class="hero-desc">{{ pageDesc }}</div>
        <div class="hero-meta">
          <span class="meta-pill">已选 {{ descriptionOfPersonalInterests.length }} 项</span>
          <span class="meta-pill subtle">共 {{ checkboxData.length }} 项可选</span>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div class="section-card">
        <div class="section-head">
          <div>
            <div class="section-title">兴趣标签</div>
            <div class="section-desc">选择与自己更贴近的兴趣爱好，方便更准确展示个人特点。</div>
          </div>
        </div>

        <van-checkbox-group
          v-model="descriptionOfPersonalInterests"
          :disabled="isReadonly"
          class="interest-group"
        >
          <van-checkbox
            v-for="item in interestOptions"
            :key="item.value"
            :name="item.value"
            shape="square"
            icon-size="0.68rem"
            class="interest-item"
          >
            <span class="interest-text">{{ item.label }}</span>
          </van-checkbox>
        </van-checkbox-group>
      </div>
    </div>

    <div class="page-actions">
      <van-button round class="action-btn secondary" @click="onCancal">{{ isReadonly ? '返回' : '取消' }}</van-button>
      <van-button v-if="!isReadonly" round type="info" class="action-btn primary" @click="onClickSave">保存</van-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { Toast } from 'vant';
import { updateUserInfo, getMatchmakerViewMemberInfo } from '../api/user';

export default {
  data() {
    return {
      checkboxData: [
        '球类运动（篮球、兵乓球、羽毛球等）',
        '体育运动（跑步、跳绳、健身等）',
        '户外活动（旅游、登山）',
        '文艺类（唱歌、跳舞、乐器）',
        '娱乐类（逛街、看电影、看书）',
        '冒险类（潜水，攀岩）',
        '智力类（拼图、拆装）',
        '游戏类（桌游、网游）',
        '休闲类（园艺、写生、摄影）',
        '美食类（火锅、烧烤等）',
        '烹饪类（中餐、西餐、糕点）',
        '其他'
      ],
      descriptionOfPersonalInterests: []
    };
  },
  computed: {
    ...mapGetters([
      'baseInfo'
    ]),
    isReadonly() {
      return !!this.$route.params.id;
    },
    pageTitle() {
      return this.isReadonly ? '查看兴趣爱好描述' : '兴趣爱好描述';
    },
    pageDesc() {
      return this.isReadonly
        ? '展示会员当前已选择的兴趣爱好标签。'
        : '完善兴趣爱好描述，让资料呈现更完整。';
    },
    interestOptions() {
      return this.checkboxData.map((item, index) => ({
        label: item,
        value: String(index + 1)
      }));
    }
  },
  methods: {
    onClickSave() {
      if (this.isReadonly) {
        this.$router.go(-1);
        return;
      }
      if (this.descriptionOfPersonalInterests.length === 0) {
        Toast.fail({ message: '请至少选择一条兴趣爱好描述', className: 'interestsErrMessage' });
        return;
      }
      let data = JSON.parse(JSON.stringify(this.baseInfo));
      data.descriptionOfPersonalInterests = this.descriptionOfPersonalInterests.join(',');
      updateUserInfo(data).then(res => {
        if (res.code === 20000) {
          this.$store.dispatch('UpdateBasicInfo', res.data);
          Toast.success({ message: '保存成功', className: 'interestsErrMessage' });
          setTimeout(() => {
            this.$router.go(-1);
          }, 300);
        }
      });
    },
    onCancal() {
      this.$router.go(-1);
    }
  },
  created() {
    if (this.isReadonly) {
      getMatchmakerViewMemberInfo(this.$route.params.id).then(res => {
        if (res.data) {
          let data = JSON.parse(JSON.stringify(res.data));
          if (data.descriptionOfPersonalInterests) {
            this.descriptionOfPersonalInterests = data.descriptionOfPersonalInterests.split(',');
          }
        }
      });
    } else {
      let data = JSON.parse(JSON.stringify(this.baseInfo));
      if (data.descriptionOfPersonalInterests) {
        this.descriptionOfPersonalInterests = data.descriptionOfPersonalInterests.split(',');
      }
    }
  }
};
</script>
<style lang='less' src='../style/checkInterests.less' />



// WEBPACK FOOTER //
// src/views/checkInterests.vue